<template>
  <section class="d-flex align-items-center justify-content-center bg-white">
    <div class="p-5 border">
      <p class="notification__control" @click="resetForm('form')"><i class="fa fa-times" aria-hidden="true"></i> </p>
      <div class="d-flex justify-content-center align-items-center pb-1">
        <img width="200" src="@/assets/TPM_yourpath.svg" alt="logo" />
      </div>
      <h1 class="text-center">Account recovery</h1>
      <p class="text-center my-3 lema">Please provide your email address below so that we can confirm that this is your account and so we can contact you after we review your request.</p>
      <template v-if="!successful">
        <el-form ref="form" :model="form" :rules="rules" :label-position="labelPosition" label-width="100px">
          <div class="form-group">
            <p class="p-1 mb-3" for="email">
              (Please be patient, it may take us some time to review and assess your request.)
            </p>
            <div class="row">
              <el-form-item label="First name" prop="firstName" class="col-sm-12 col-lg-6">
                <el-input @focusout.native="checkValidateForm" v-model="form.firstName"></el-input>
              </el-form-item>
              <el-form-item label="Last name" prop="lastName" class="col-sm-12 col-lg-6">
                <el-input @focusout.native="checkValidateForm" v-model="form.lastName"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="Box number" prop="boxNumber" class="col-sm-16 col-lg-6">
                <el-input @focusout.native="checkValidateForm" v-model="form.boxNumber" v-mask="'9999999'"></el-input>
              </el-form-item>
              <el-form-item label="Email" prop="email" class="col-sm-16 col-lg-6">
                <el-input @focusout.native="checkValidateForm" v-model="form.email"></el-input>
              </el-form-item>
            </div>
            <el-form-item>
              <a  :class="[{'isDisabled' : !isButtonEnabled} ,{'wsp':isButtonEnabled}]" @click="onSubmit" :href="`https://api.whatsapp.com/send?phone=${'+15623998088'}&text=: ${message}`" target="_blank"><i class="fa fa-whatsapp"></i> (562)399-8088</a>
              <!--<el-button type="submit" size="small" class="btn btn-primary" @click="onSubmit">Submit</el-button>-->
              <el-button size="small" class="btn" @click="resetForm('form')">Cancel</el-button> 
            </el-form-item>
          </div>
        </el-form>
      </template>
      <transition name="slide-fade">
        <template v-if="successful">
          <div class="mt-4 text-center">
            <i class="fa fa-check-circle text-success mr-2 icon-success"></i>
            <p>
              Mail sent successfully! We have sent a link to
            </p>
            <p class="email">{{ form.email }}</p>
            <p>Check your email and recover your password</p>

            <!-- <button class="btn btn-link mt-3" @click="$router.push({ name: 'wlelcome' })">
              Home
            </button> -->
          </div>
        </template>
      </transition>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ForgotPassword',
  data() {
    return {
      form: {
        email: null,
        firstName:'',
        lastName:'',
        boxNumber:'',
      },
      rules:{
        firstName: [
          { required: true, message: 'Please input first name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Please input last name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        boxNumber: [
          {
            required: true,
            message: 'Please input box license number',
            trigger: 'blur',
          },
        ],
        email: [
          { required: true, message: 'Please input email address', trigger: 'blur' },
          {
            type: 'email',
            message: 'Please input correct email address',
            trigger: ['blur', 'change'],
          },
        ],
      },
      labelPosition: 'left',
      successful: false,
      message:'',
      isButtonEnabled:false,
    };
  },
  methods: {
    onSubmit() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          console.log('valido');
          this.message= `Customer: ${this.form.firstName} ${this.form.lastName} - Box Number: ${this.form.boxNumber} - Email: ${this.form.email}`;
          console.log(this.message);
         /* this.$httpMain
            .post(` `, {
              email: this.form.email,
            })
            .then(() => {
              this.successful = true;
            })
            .catch(() => {
              // this.successful = true;
              console.log(this.successful);
            });*/
        } else console.log('invalido');
      });
    },
    resetForm(formName) {
      this.$emit('cancel');
      this.$refs[formName].resetFields();
    },
    checkValidateForm(){
      this.$refs['form'].validate((valid) => {
        if (valid) {
          console.log('submit!');
          this.isButtonEnabled=true;
        } else {
          console.log('error submit!!');
          this.isButtonEnabled=false;
        }
      });
    }
  },
};
</script>

<style lang="scss" scoped>
section{
  word-break: normal;
  padding: 1rem;
  background-color: white;
  border-radius: 10px;
  @media all and (min-width: 992px) {
    padding: 2rem;
  }
}
.email{
  color: #148ce0
}
.isDisabled{
  pointer-events: none;
  cursor: default;
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  background-color: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  margin-right: 10px;
  text-decoration: none;
}
.btn-primary{
  color: white;
  background: #148ce0
}
.icon-success{
  font-size: 5em;
}
.lema{
  max-width: 350px;
  margin: auto;
}
.invalid-field{
  color: #d50000;
  font-size: 12px;
}
.slide-fade-enter-active{
  transition: all .3s ease;
}

.slide-fade-leave-active{
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to{
  transform: translateX(10px);
  opacity: 0;
}
.wsp{
  padding: 9px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  background-color: #25D366;
  border: 1px solid #DCDFE6;
  color: white;
  margin-right: 10px;
  text-decoration: none;
  cursor: pointer;
  &:hover{
    background-color: #34B7F1;
  }
}
.border{
  position: relative;
  box-shadow: 0px 5px 10px rgba(0,0,0,0.5);
}
.notification__control{
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
}
</style>
